<template>
    <v-dialog persistent scrollable 
        v-model="dialogShow" 
        max-width="80%"
    >
    <!-- :max-width="!showNota && !showLote && padrao == 'NA' ?'80%' :'60%'"     -->
    <v-card>
        
        
            <v-card-title class="pa-1">
                <v-spacer></v-spacer><v-btn icon dark
                    @click="showNoAs && !showNota && !showLote ?showNoAs = false 
                    :showNota && !showNoAs && !showLote ?showNota = false 
                    :showLote && !showNota && !showNoAs ?showLote = false 
                    :!showNoAs && !showNota && !showLote ?close() :close()"
                ><v-icon color="primary">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text class="py-1">
                <AdicionarNota
                    v-show="showNota && !showNoAs && !showLote 
                    || !showNota && !showNoAs && !showLote && padrao == 'AN'"
                    :dadosCronograma="dadosCronograma"
                    :formData="formData"
                    :formRules="formRules"
                    :validateForm="validateForm"
                    :updateNotaFiscalFormValid="(validation)=>notaFiscalFormValid = validation"
                    :sendFile="(fl) => file = fl"
                    :obrigatorio="obrigatorio"
                    :getLotes="(param1, param2) => getLotes(param1, param2)"
                    :tipoE="tipoDocEdi"
                    :edicao="edicaoN"
                    :parametros="parametros"
                />

                <AssociarLote
                    v-show="showLote && !showNota && !showNoAs 
                    || !showLote && !showNota && !showNoAs && padrao == 'AL'"
                    :info="dadosNota"
                    :list="lotesList"
                    :assocLotes="(list_lotes) => listLotesAssociados = list_lotes"
                    :cronograma="dadosCronograma"
                    :parametros="parametros"
                />

                <NotasAssociadas
                    v-show="showNoAs && !showNota && !showLote 
                    || !showNoAs && !showNota && !showLote && padrao == 'NA'"
                    :userData="userData"
                    :list="notasList"
                    :parameter="dadosCronograma"
                    :cronograma="dados"
                    :delItem="(item, filtro, tab) => deleteNota(item, filtro, tab)"
                    :getNotas="(id) => getNotas(id)"
                    :assocItem="(item) => getLotes(item)"
                    :getFile="(doc) => getDocument(doc)"
                    :disableAssociarLote="disableAssociarLote"
                    :getListFiltrada="(form) => listFiltradaGet(form)"
                    :listFiltrada="notasListFiltrada"
                    :parametros="parametros"
                    :fechado="fechei"
                />
            </v-card-text>

            <v-card-actions v-if="!lotesNull" class="px-5 pt-0 pb-5">
                <v-btn
                    v-if="showNota && !showNoAs && !showLote 
                    || showLote && !showNota && !showNoAs 
                    || !showNota && !showNoAs && !showLote && padrao == 'AN' 
                    || !showLote && !showNota && !showNoAs && padrao == 'AL'"
                    small
                    depressed
                    outlined
                    height="30px"
                    color="primary"
                    @click="showNota ? showNota = false 
                    :showLote? showLote = false  : close()"
                >Cancelar
                    <!-- @click="showNota && !showNoAs && !showLote ?showNota = false 
                    :showLote && !showNota && !showNoAs ?showLote = false 
                    :!showNoAs && !showNota && !showLote ? close() : close()" -->
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="showNota && !showNoAs && !showLote 
                    || showLote && !showNota && !showNoAs 
                    || !showNota && !showNoAs && !showLote && padrao == 'AN' 
                    || !showLote && !showNota && !showNoAs && padrao == 'AL'"
                    small
                    depressed
                    height="30px"
                    color="primary"
                    @click="showNota && !showNoAs && !showLote ? saveNota(formData) 
                    :showLote && !showNota && !showNoAs ?saveLotes(listLotesAssociados) 
                    :!showNota && !showNoAs && !showLote && padrao == 'AN' ? saveNota(formData) 
                    :!showLote && !showNota && !showNoAs && padrao == 'AL' ? saveLotes(listLotesAssociados) 
                    :null"
                > Salvar
              </v-btn>
            </v-card-actions>

            <v-card-actions v-else class="px-5 pt-0 pb-5">
                <v-spacer></v-spacer>
                <v-btn
                    small
                    depressed
                    height="30px"
                    color="primary"
                    @click="showLote && !showNota && !showNoAs ?showLote = false 
                    :!showNoAs && !showNota && !showLote ?close() :close()"
                > Fechar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex"
import AdicionarNota from '@/components/nota_fiscal/AdicionarNota'
import AssociarLote from '@/components/nota_fiscal/AssociarLote'
import NotasAssociadas from '@/components/nota_fiscal/NotasAssociadas'
export default {
    components: {
        AdicionarNota,
        AssociarLote,
        NotasAssociadas,
    },
    props: {
        
    },
    updated(){
        this.fechei = false
    },
    data() {
        return {
            dialogShow: false,
            disableAssociarLote: false,
            // Comandos gerais
            showNota: false,
            showLote: false,
            showNoAs: false,
            dadosCronograma: {},
            notasList: [],

            // Associar lotes a nota
            lotesNull: false,
            dadosNota: {},
            lotesList: [],
            listLotesAssociados: [],

            // Adicionar nota fiscal
            validateForm: false,
            notaFiscalFormValid: true,
            file: null,
            obrigatorio: [],
            formData: {
                id: null,
                numero: null,
                dt_emissao: null,
                valor: 0.00,
                link: null,
                anexo: null,
                dt_alteracao: null,
                associar: false,
                tipo: null,
                data_venc_titulo: null,
                nr_titulo: null,
                cnpj: null
            },
            notasListFiltrada: [],
            tipoDocEdi: 0,
            edicaoN: false,
            fechei: false,
            formDofiltro: {}
        }
    },
    computed: {
        ...mapState({
            userData: (state) => state.userData.userData,
            grupoEconomico: (state) => state.permissions.grupoEconomico,
            formRules: (state) => state.formRules,
            dialog:(state) => state.notasFiscais.dialog,
            padrao:(state) => state.notasFiscais.padrao,
            dados:(state) => state.notasFiscais.dados,
            parametros:(state) => state.notasFiscais.parametros
        }),
    },
    watch: {
        async dialog(bool) {
            if (bool) {
                this.$store.commit("showLoader",  { circle: true })
                let opts = {grupo_economico: this.grupoEconomico, id: this.dados.cronograma_id}
                await this.getDetalhesCronograma(opts).then(resp => { 
                    this.dadosCronograma = resp
                    this.dadosCronograma.grupo_economico= this.grupoEconomico
                    this.hasLotesValidos().then(()=> this.dataCalls(resp.config))
                })
            } else {
                this.dialogShow = false
            }
        },
        showNota(bool) {if (!bool) this.dataCalls()},
        showLote(bool) {if (!bool) this.dataCalls()},
        showNoAs(bool) {if (!bool) this.dataCalls()},

    },
    methods: {
        ...mapActions({
            "getDetalhesCronograma":"faturamento/getDetalhesCronograma",
            "getDocument":"documents/getDocument",
        }),
        close() {
            this.edicaoN = false
            this.$store.commit('notasFiscais/closeDialog')
            this.notasListFiltrada = []
            this.notasList = []
            this.fechei = true
        },
        resetForm() {
            this.formData = {
                id: null,
                numero: null,
                dt_emissao: null,
                valor: 0.00,
                link: null,
                anexo: null,
                associar: false,
                tipo: null,
                data_venc_titulo: null,
                nr_titulo: null,
                cnpj: null
            }
        },
        dataCalls() {
            this.resetForm()
            this.lotesNull = false
            switch(this.padrao) {
                case'AN':          //Adicionar Nota
                    this.getNotas()
                break;
                case'NA':         //Notas Associadas
                    this.getList()
                break;
                case'AL':         //Associas nota a lote
                default:
                break;
            }
        },
        getList(evento, filtro=null) {
            
            let obj = {query: [{ Modulo: "Faturamento", Acao: "getnotasfiscais", 
                Payload: {
                    grupo_economico: this.grupoEconomico, 
                    cronograma_id: filtro ? filtro.cronograma_id : this.dados.cronograma_id, 
                    operadora_ans_id: this.dados.operadora_ans_id,
                    prestador_id: this.dados.prestador_id,
                    tipo: filtro ? filtro.tipo : null,
                    data_ate: filtro ? filtro.data_ate : null,
                    data_entre: filtro ? filtro.data_entre : null,
                    numero: filtro ? filtro.numero : null,
                    nr_titulo: filtro ? filtro.nr_titulo : null,

                }
            }], noLoader: true}
            
            this.$store.dispatch("request/doRequest", obj).then((response) => {
                this.dialogShow = true
                if (!response || response.isAxiosError || !response.sucesso) {
                    this.$store.commit("hideLoader")
                    return
                } 
                if(filtro == null){
                    //if (response.dados && response.dados.length == 0) {
                        //if (evento) this.close()
                        //else this.$store.state.notasFiscais.padrao = 'AN'
                    //} else {
                        //this.$store.state.notasFiscais.padrao = 'NA'
                        this.notasList = response.dados
                    //}
                }
                else
                {
                    this.notasListFiltrada = response.dados
                }
            })
        },
        getNotas(idNota) {
            this.file = null
            this.$store.commit("showLoader",  { circle: true })
            this.obrigatorio = this.dadosCronograma.config && this.dadosCronograma.config.FAT_NOTA_FISCAL_CAMPOS_OBRIGATORIOS
                ? this.dadosCronograma.config.FAT_NOTA_FISCAL_CAMPOS_OBRIGATORIOS : []
            let Payload = {grupo_economico: this.grupoEconomico, id: idNota}
            if(idNota != null) {
                let obj = {query: [{ Modulo: "Faturamento", Acao: "getnotafiscal", Payload }]}
                this.$store.dispatch("request/doRequest", obj).then(response => {
                    this.formData = response.notaFiscal
                    this.tipoDocEdi = Number(this.formData.tipo)
                    this.edicaoN = true
                    this.showNota = true
                    this.$store.commit("hideLoader")
                })
            } else {
                this.resetForm()
                this.validateForm = false
                this.formData.cnpj = this.dadosCronograma.cnpj
                this.tipoDocEdi = 0
                this.showNota = true
                this.edicaoN = false
                this.$store.commit("hideLoader")
            }
        },
        async hasLotesValidos(){
            let valid = false
            let acao = this.dados.complementar ? "getlotescomplementares" :"getlotes"
            let payload = {grupo_economico: this.grupoEconomico, cronograma_id: this.dados.cronograma_id, prestador_id: this.dadosCronograma.prestador_id}
            let obj = {query: [{Modulo: "Faturamento", Acao: acao, Payload: payload}], noLoader: true}
            await this.$store.dispatch("request/doRequest", obj).then(response => {
                valid = this.dados.complementar?
                       response.dados.filter(el => el.etapa >= 20 && !el.proc_trd_tem_erro).length > 0
                       :response.dados.filter(el => !el.is_deleted && el.etapa > 10   && el.proc_trd_tem_erro == 0 && (el.env_op_tem_erro == 0 || (el.env_op_tem_erro == 1 && el.fl_tratado == 1))).length > 0
            })
            this.disableAssociarLote = !valid && !(this.dadosCronograma.config && this.dadosCronograma.config.FAT_ACEITA_XML_INVALIDO)
            return !valid

        },
        getLotes(item, attL=false) {
            let acao = this.dados.complementar ?"getlotescomplementares" :"getlotes"
            this.dadosNota = item
            let payload = {grupo_economico: this.grupoEconomico, cronograma_id: this.dados.cronograma_id, prestador_id: this.dadosCronograma.prestador_id}
            let obj = {query: [{Modulo: "Faturamento", Acao: acao, Payload: payload}]}
            this.$store.dispatch("request/doRequest", obj).then(response => {
                // let lotes = []
                // if(item){
                //     lotes = response.dados.filter((item) => !item.nfs_associadas.length || item.nfs_associadas.includes(this.dadosNota.id))
                // } else {
                //     lotes = response.dados.filter((item) => !item.nfs_associadas.length)
                // }
                // if (lotes.length == 0) this.lotesNull = true 
                let valid = this.dados.complementar 
                    ?response.dados.filter(el => el.etapa >=20 && (this.dadosCronograma.config && this.dadosCronograma.config.FAT_ACEITA_XML_INVALIDO) || (el.etapa >=20 && el.proc_trd_tem_erro == 0)).length > 0
                    :response.dados.filter(el => !el.is_deleted && el.etapa >= 20  && ((el.env_op_tem_erro == 0 && el.proc_trd_tem_erro == 0)  || (el.etapa >=20 && el.env_op_tem_erro == 1 && el.fl_tratado == 1 && el.proc_trd_tem_erro == 0))).length > 0
                this.lotesNull = !valid 
                if (!valid && !(this.dadosCronograma.config && this.dadosCronograma.config.FAT_ACEITA_XML_INVALIDO)) {
                    this.disableAssociarLote = true
                    let paramModal = {
                        type: "error",
                        title: "Erro!",
                        message: "Não existem lotes válidos para serem associados às notas fiscais.",
                        callback: () => null,
                        btConfirm: { name: "Fechar", show: true, color: "error" },
                        btCancel: { show: false }
                    }
                    this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
                } else {
                    this.disableAssociarLote = false
                    this.lotesList = this.dados.complementar 
                        ?response.dados.filter(el => el.etapa >=20 && this.dadosCronograma && this.dadosCronograma.config && this.dadosCronograma.config.FAT_ACEITA_XML_INVALIDO || (el.etapa >=20 && el.proc_trd_tem_erro == 0))
                        : response.dados 
                    if(attL){
                        return
                    }
                    this.showLote = true
                    this.$store.commit("hideLoader")
                }
            
            })
        },
        saveLotes(listLotes) {
            let paramModal = {
                type: "warning",
                title: "Confirmar ação",
                message: "Você poderá editar novamente quando necessário",
                callback: () => { this.associaLotes(listLotes) },
                btConfirm: { name: "Salvar", show: true },
                btCancel: { name: 'Cancelar', show: true }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        },
        associaLotes(item) {

            let { prestador_id, operadora_ans_id, id } = this.dadosCronograma

            let loteObj = item.map(lote => Object.assign({ 
                lote_id: lote.id, 
                dt_alteracao: lote.nota_fiscal_dt_alteracao 
            }));
            
            var payload = Object.assign({
                lotes: [...loteObj], 
                nota_fiscal_id: [this.dadosNota.id], 
                prestador_id, 
                operadora_ans_id, 
                cronograma_id: id
            });
            let obj = {
                query: [{ 
                    Modulo: "Faturamento",
                    Acao: "associarnotafiscal",
                    Payload: {
                        grupo_economico: this.grupoEconomico,
                        ...payload
                    }
                }],
            }
            this.$store.dispatch('request/doRequest', obj).then((response) => {
                if (!response || response.isAxiosError || response.error) {
                    this.$store.commit('hideLoader');
                    return;
                }
                this.showLote = false
                let paramModal = {
                    type: 'success',
                    title: 'Sucesso!',
                    message: response.mensagem ?? 'Associação efetuada com sucesso',
                    callback: this.getList(false, this.formDofiltro),
                    btConfirm: { name: 'Ok', show: true },
                    btCancel: { show: false },
                };
                this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
            })
        },
        saveNota(formData) {
            
            this.validateForm = true
            this.$nextTick(()=> {
                if(!this.notaFiscalFormValid) {
                    this.validateForm = false
                    return
                }
                if (formData.id == null) {
                    let opts = {...formData}
                    this.saveForm(opts)
                    
                } else {
                    this.associados(this.formData)
                }
                this.validateForm = false
            })
        },
        associados(val) {
            let select = []
            let lotes = val.lotes
            select = lotes.reduce((arr, item) => {
                let associadas = item.associada == null ? false :true
                let id = item.id
                let dtAlteracao = item.dt_alteracao
                let obj = {lote_id: id, associada: associadas, dt_alteracao: dtAlteracao}
                if (item) { arr.push(obj) }
                return arr
            },[])
            let opts = {
                id: val.id,
                numero: val? val.numero: null,
                dt_emissao: val.dt_emissao,
                valor: val.valor,
                link: val.link,
                associaLote: select,
                dt_alteracao: val.dt_alteracao,
                tipo: val.tipo,
                data_venc_titulo: val.data_venc_titulo,
                nr_titulo: val.nr_titulo,
                cnpj: val.cnpj
            }
            this.saveForm(opts)
        },
        saveForm(formData) {
            
            formData.grupo_economico = this.grupoEconomico
            formData.cronograma_id = this.dados.cronograma_id
            formData.operadora_ans_id = this.dadosCronograma.operadora_ans_id
            formData.prestador_id = this.dadosCronograma.prestador_id
            let acao = formData.id ? "updatenotafiscal" : "addnotafiscal" 
            let payload = JSON.stringify(formData)
            var data = new FormData();
            data.append('Modulo', 'Faturamento');
            data.append('Acao', acao);
            data.append('Payload', payload);
            data.append('File', this.file);

            this.$store.dispatch("request/sendFile", data).then((response) => {
                if (!response || response.isAxiosError || !response.sucesso) {
                    this.$store.commit("hideLoader");
                    return;
                }
                this.formData = {}
                if(formData.associar){
                    let notaId = response.id
                    
                    let loteObj = this.lotesList.map(lote => Object.assign({ 
                        lote_id: lote.id, 
                        dt_alteracao: lote.nota_fiscal_dt_alteracao 
                    }));
                    var payload = Object.assign({
                        lotes: [...loteObj], 
                        nota_fiscal_id: [notaId], 
                        prestador_id: this.dadosCronograma.prestador_id 
                    });
                    let obj = {
                        query: [{ 
                            Modulo: "Faturamento",
                            Acao: "associarnotafiscal",
                            Payload: {
                                grupo_economico: this.grupoEconomico,
                                ...payload
                            }
                        }],
                    }
                    
                    this.$store.dispatch('request/doRequest', obj).then((resp) => {
                        if (!resp || resp.isAxiosError || resp.error) {
                            this.$store.commit('hideLoader');
                            return;
                        }
                        this.showNota = false
                
                        let paramModal = {
                            type: "success",
                            title: "Sucesso!",
                            message: 'Nota fiscal inserida e associada com sucesso',
                            callback: () => this.getList(true),
                            btConfirm: { name: "Ok", show: true },
                        }
                        this.$store.commit("confirmMessage/showConfirmMessage", paramModal); 
                    })
                    
                } else {
                    this.showNota = false
                
                    let paramModal = {
                        type: "success",
                        title: "Sucesso!",
                        message: response.mensagem,
                        callback: () => this.getList(true),
                        btConfirm: { name: "Ok", show: true },
                    }
                    this.$store.commit("confirmMessage/showConfirmMessage", paramModal); 

                }
            })
        },
        deleteNota(item, filtro, tab) {
            filtro = tab == 1 ? filtro : null
            let paramModal = {}
            let payload = {grupo_economico: this.grupoEconomico, id: item.id, dt_alteracao: item.dt_alteracao, prestador_id: this.dadosCronograma.prestador_id}
            let obj = {query: [{Modulo: "Faturamento", Acao: "deletenotafiscal", Payload: payload}]}
            paramModal = {
                type: "error",
                title: "Excluir nota fiscal?",
                message: `Ao excluir nota fiscal de número: ${item.numero}, não estará mais disponível no cronograma. Essa alteração não poderá ser desfeita.`,
                callback: () => {
                    this.$store.dispatch("request/doRequest", obj).then((response) => {
                        if (!response || response.isAxiosError || !response.sucesso) {
                            this.$store.commit("hideLoader");
                        return;
                        }
                        paramModal = {
                            type: "success",
                            title: "Sucesso!",
                            message: response.mensagem,
                            callback: () => { this.getList(false, filtro) },
                            btConfirm: { name: "Ok", show: true },
                            btCancel: { name: 'Cancelar', show: false }
                        }
                        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
                    })
                },
                btConfirm: { name: "Ok", show: true, color: '#D0021B' },
                btCancel: { name: 'Cancelar', show: true }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        },
        listFiltradaGet(form) {
            this.formDofiltro = form
            this.getList(false, form)
        }
    }
}
</script>

<style>

</style>